export default __webpack_public_path__ + "static/media/39t.f11d1319.jpg";